import { Euler, MathUtils } from "three";

const vector = value => ({ X: value.x, Y: value.y, Z: value.z });

// Read the displayed pose from the runtime objects. The document can contain a
// different base pose while a State, embedded animation, or gizmo is active.
export function readObjectTransforms(objects, indices) {
    const result = [];
    for (const index of new Set(indices)) {
        const object = objects?.get(index);
        if (!object) continue;
        const rotation = new Euler().setFromQuaternion(object.quaternion, "XYZ");
        result.push({ index, position: vector(object.position), scale: vector(object.scale),
            rotation: { X: MathUtils.radToDeg(rotation.x), Y: MathUtils.radToDeg(rotation.y), Z: MathUtils.radToDeg(rotation.z) } });
    }
    return result;
}

export function formatTransformValue(value) {
    if (!Number.isFinite(value)) return "—";
    if (value !== 0 && Math.abs(value) < 0.0005) return value.toExponential(2);
    return String(Number(value.toFixed(3)));
}
